import { ChangeEvent, ReactElement } from 'react';

type DropdownProps = {
  label: string;
  name: string;
  options: any[];
  field: string;
  noMarginTop?: boolean;
  selected?: any;
  hasError?: boolean;
  isDisabled?: boolean;
  handleOptionsSelect: (e: ChangeEvent<HTMLSelectElement>) => void;
};

/**
 * A dropdown react component.
 * @param props - DropdownProps.
 * @returns - React element to capture user selection.
 */
export default function Dropdown(props: DropdownProps): ReactElement {
  const {
    label,
    name,
    options,
    handleOptionsSelect,
    field,
    noMarginTop,
    selected,
    hasError,
    isDisabled
  } = props;
  return (
    <div className={`w-full ${!noMarginTop && 'mt-4'}`}>
      <label htmlFor="dropdown-input" className="text-gray-500 dark:text-gray-500 text-sm">
        {label}
        <select
          id="dropdown-input"
          disabled={isDisabled}
          name={name}
          onChange={handleOptionsSelect}
          value={JSON.stringify(selected)}
          className={`relative w-full capitalize py-2 mt-1 text-base font-normal text-gray-300 dark:text-gray-300 rounded bg-gray-50 dark:bg-container-500 border focus:dark:border-primary-300 focus-within:dark:ring-transparent ${
            hasError ? 'border-error-300' : 'border-gray-700'
          }`}
        >
          <option value="" aria-hidden="true" />
          {options.map((option: any) => (
            <option
              className="font-normal text-gray-500 dark:text-gray-200 py-4 capitalize"
              key={option[field]}
              value={JSON.stringify(option)}
            >
              {option[field]}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
